<template>
  <v-toolbar color="white" dense flat class="filter-bar">
    <v-btn-toggle mandatory class="no-shadow">
      <v-btn flat color="white" @click="$emit('filterOrders', 'pending')"    value="pending">Pending</v-btn>
      <v-btn flat color="white" @click="$emit('filterOrders', 'active')"     value="active">Active</v-btn>
      <v-btn flat color="white" @click="$emit('filterOrders', 'shipped')"    value="shipped">Shipped</v-btn>
      <v-btn flat color="white" @click="$emit('filterOrders', 'all')"        value="all">All</v-btn>
      <v-btn flat color="white" @click="$emit('filterOrders', 'unfinished')" value="unfinished">Unfinished</v-btn>
      <v-btn flat color="white" @click="$emit('filterOrders', 'canceled')"   value="canceled">Canceled</v-btn>
    </v-btn-toggle>
    <v-spacer/>
    <v-text-field @keyup.enter="$emit('search', searchFor)"
                  @click:clear="$emit('search', '')"
                  v-model="searchFor"
                  :value="search"
                  single-line
                  hide-details
                  append-icon="search"
                  flat
                  clearable />
      <span class="pr-4"/>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    search: String
  },

  data () {
    return {
      searchFor: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// filter-bar.vue?05ddfeda